<template>
    <div name="privacy">
        <div class="header">
            <div class="button-area" @click="back">
                <img class="back" src="../../assets/back.png" />
            </div>
            <span>개인정보 처리방침</span>
        </div>
        <div v-if="policies !== null" style="margin-top: 30px;">
            <span class="title">변경 이력</span>
            <div class="list">
                <div v-for="(policy, index) in policies">
                    <span v-if="policy.id != 3" class="label">{{convertTimestamp(policy.revisionDate)}} 개정</span><span v-else class="label">{{convertTimestamp(policy.revisionDate)}} 제정</span> <span class="link" v-if="selected != policy.id" @click="selectRevision(policy.id)">- 확인하러 가기</span>
                </div>
            </div>
        </div>
        <div style="margin-top: 50px">
            <contents0807 v-if="selected === 20" />
            <contents20240314 v-if="selected === 19" />
            <div v-if="selected < 19" v-html="content">
            </div> 
        </div>
    </div>
</template>

<script>
import Constant from '@/constant';
import contents0807 from '@/pages/barocare/contents/privacy/20240807';
import contents20240314 from '@/pages/barocare/contents/privacy/20240314';
export default {
    name: 'privacy',
    components: {
        contents0807,
        contents20240314
    },
    data: function()
    {
        return {
            policies: [
                {
                    revisionDate: '2024-08-05',
                    id: 20
                },
                {
                    revisionDate: '2024-03-14',
                    id: 19
                },
                {
                    revisionDate: '2024-03-06',
                    id: 18
                },
                {
                    revisionDate: '2023-08-31',
                    id: 16
                },
                {
                    revisionDate: '2023-07-17',
                    id: 14
                },
                {
                    revisionDate: '2022-11-30',
                    id: 10
                },
                {
                    revisionDate: '2022-11-01',
                    id: 8
                },
                {
                    revisionDate: '2022-10-20',
                    id: 7
                },
                {
                    revisionDate: '2022-10-17',
                    id: 6
                },
                {
                    revisionDate: '2022-06-03',
                    id: 4
                },
                {
                    revisionDate: '2020-06-10',
                    id: 3
                }
            ],
            selected: 20,
            content: null
        }
    },
    methods: {
        selectRevision: function(index)
        {
            this.selected = index;
            if(index < 19)
            {
                this.$store.dispatch(Constant.FETCH_POLICY, {policyId: index})
                    .then((res) => {
                        this.content = res.content;
                    })
            }
        },
        convertTimestamp: function(stamp)
        {
            
            var date = new Date(stamp);
            var month = date.getMonth() + 1;
            var text = '오전';
            var hour = date.getHours();
            if(date.getHours() >= 12)
            {
                text = '오후'

                if(hour != 12)
                {
                    hour = hour - 12;
                }
            }

            return date.getFullYear() + "년 " + this.leadingZeros(month, 2) + "월 " + this.leadingZeros(date.getDate(), 2) + "일 ";
        },
        leadingZeros: function(n, digits) {
            var zero = '';
            n = n.toString();
            if (n.length < digits) {
                for (var i = 0; i < digits - n.length; i++)
                    zero += 0;
            }
            return zero + n;
        },
        back: function()
        {
            this.$router.push({path: '/barocare'})
        }
    }
}
</script>

<style scoped>
    .title {
        font-size: 18px;
    }
    .label {
        font-size: 15px;
        color: gray;
    }
    .list {
        display: flex;
        flex-direction: column;
        gap: 3px;
        margin-top: 10px;
    }
    .link {
        text-decoration: underline;
        cursor: pointer;
        color: blue;
        font-size: 15px;
    }
    .header{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .back {
        width: 15px;
        margin-top: -2px;
    }
    .button-area {
        width: 35px;
        height: 35px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/pages/barocare/Privacy.vue